import Button from '@/components/Buttons/Button';
import Dialog from '@/components/Dialog/BootstrapDialog';
import SmallCloseIcon from '@/images/SmallCloseIcon.svg';
import Warning from '@/images/Warning.svg';
import { StyleCollection } from '@/utils/types';
import styled from '@emotion/styled';
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

const styles: StyleCollection = {
    closeButton: () => ({
        fontSize: '1.6rem',
    }),
    submitButton: () => ({
        fontSize: '1.6rem',
    }),
    dangerButton: theme => ({
        fontSize: '1.6rem',
        color: theme.colors.secondary,
    }),
    dialog: {
        padding: '10px',
    },
    dialogContent: {
        padding: '1rem 2rem',
        marginBottom: '1rem',
    },
};

const WarningIcon = styled.div`
    background-color: ${props => props.theme.colors.primary};
    mask: url(${Warning}) no-repeat center;
    width: 2.3rem;
    height: 2.3rem;
    position: relative;
    margin-right: 5px;
`;

const Title = styled(DialogTitle)<{ titleLocation: 'start' | 'center' }>`
    white-space: pre-line;
    font-size: 22px !important;
    justify-content: ${({ titleLocation }) => titleLocation};
`;

const CloseIcon = styled.img`
    align-self: end;
`;

interface Props {
    open: boolean;
    onCancel?: () => void;
    onClose: () => void;
    onSubmit: () => void;
    title: string;
    subtitle: string | React.ReactNode;
    danger?: boolean;
    submitTitle?: string | React.ReactNode;
    cancelTitle?: string | React.ReactNode;
    content?: React.ReactNode;
    warningIcon?: boolean;
    showCloseIcon?: boolean;
    titleLocation?: 'start' | 'center';
    transition?: any;
}

export default function ActionDialog({
    open,
    onCancel,
    onClose,
    onSubmit,
    title,
    subtitle,
    danger,
    submitTitle,
    cancelTitle = 'Cancel',
    warningIcon = true,
    showCloseIcon,
    titleLocation = 'start',
    transition,
}: Props) {
    const handleSubmit = () => {
        onSubmit();
        onClose();
    };

    const handleCancel = () => {
        onCancel?.();
    };

    return (
        <Dialog
            open={open}
            width="50rem"
            rootstyle={styles.dialog}
            contentstyle={styles.dialogContent}
            onClose={onClose}
            TransitionComponent={transition}>
            {showCloseIcon && <CloseIcon src={SmallCloseIcon} onClick={handleCancel} />}
            <Title titleLocation={titleLocation}>
                {warningIcon && <WarningIcon />}
                {title}
            </Title>
            <DialogContent>
                <DialogContentText>{subtitle}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button fullWidth variant="outlined" onClick={handleCancel} color="secondary" sx={styles.closeButton}>
                    {cancelTitle}
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleSubmit}
                    color={danger ? 'error' : 'secondary'}
                    sx={danger ? styles.dangerButton : styles.submitButton}>
                    {submitTitle || 'Continue'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
